"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionValidator = void 0;
var core_1 = require("@athena-portal/core");
var Types_1 = require("../Types");
var QuestionValidator = exports.QuestionValidator = /** @class */ (function () {
    function QuestionValidator() {
    }
    QuestionValidator.prototype.validate = function (value, context) {
        return __awaiter(this, void 0, void 0, function () {
            var validations, results, errors, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        validations = context.question.validations;
                        if (!validations) {
                            return [2 /*return*/, Promise.resolve({ valid: true })];
                        }
                        return [4 /*yield*/, Promise.all(validations.map(function (v) {
                                var validation = _this.journeyComponentsManager.fetchValidation(v.type);
                                if (validation) {
                                    return new validation.method(v.settings, _this.validationCommandsExecutor)
                                        .validate(value, __assign({ validation: v, fieldName: context.question.label, errorMessage: v.errorMessage }, context));
                                }
                                return Promise.resolve({ valid: false, message: "Invalid method: ".concat(v.type) });
                            }))];
                    case 1:
                        results = _a.sent();
                        errors = results.filter(function (x) { return x.valid === false; });
                        result = {
                            valid: errors.length === 0,
                            errors: errors.map(function (x) { return x.errorMessage; })
                        };
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    __decorate([
        (0, core_1.inject)(core_1.TypeDefs.JourneyComponentsManager),
        __metadata("design:type", Object)
    ], QuestionValidator.prototype, "journeyComponentsManager", void 0);
    __decorate([
        (0, core_1.inject)(Types_1.Types.ValidationCommandsExecutor),
        (0, core_1.optional)(),
        __metadata("design:type", Object)
    ], QuestionValidator.prototype, "validationCommandsExecutor", void 0);
    QuestionValidator = __decorate([
        (0, core_1.injectable)()
    ], QuestionValidator);
    return QuestionValidator;
}());
//# sourceMappingURL=QuestionValidator.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/journey-services/dist/impl/QuestionValidator.js
// module id = 2061
// module chunks = 0